import type { WorkspaceSessionView } from "./types";

export interface WorkspaceAccountProps {
  manageLabel?: string;
  onManageAccount?: (() => void) | undefined;
  onSignOut?: (() => void) | undefined;
  session: WorkspaceSessionView;
}

function initials(session: WorkspaceSessionView): string {
  const source = session.identity.displayName?.trim() || session.identity.email;
  return source
    .split(/\s+|@/u)
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0]?.toUpperCase())
    .join("");
}

/**
 * Authenticated shell content only. It intentionally performs no network calls;
 * the auth integration owns session loading and supplies explicit actions.
 */
export function WorkspaceAccount({
  manageLabel = "Manage",
  onManageAccount,
  onSignOut,
  session,
}: WorkspaceAccountProps) {
  const name = session.identity.displayName?.trim() || session.identity.email;

  return (
    <div className="workspace-account" aria-label="Signed-in account">
      <span className="workspace-account__avatar" aria-hidden="true">
        {initials(session)}
      </span>
      <span className="workspace-account__identity">
        <strong>{name}</strong>
        {name === session.identity.email ? null : (
          <small>{session.identity.email}</small>
        )}
      </span>
      {onManageAccount === undefined ? null : (
        <button type="button" onClick={onManageAccount}>
          {manageLabel}
        </button>
      )}
      {onSignOut === undefined ? null : (
        <button type="button" onClick={onSignOut}>
          Sign out
        </button>
      )}
    </div>
  );
}
